// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@disy/cadenza-icons/chevron-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@disy/cadenza-icons/chevron-up.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.focus-outline,
.focus-outline-keynav {
  outline: none; /* disable the native focus outline (for :focus-visible) */
  transition: box-shadow var(--default-transition); /* animate our focus outline */
}

:is(.focus-outline,.focus-outline-keynav):focus {
    border-radius: var(--outline, 1px); /* add rounded corners to the outline */
    box-shadow: var(--outline, var(--default-outline));
    outline: var(--outline, var(--default-native-outline));
  }

.focus-outline-keynav {
  --outline: var(--is-not-keynav);
}

.summary,
.expanded-toggle {
  background: none;
  border: none;
  padding: 0;
  text-align: left;
}

:host(:not([non-toggleable])) :is(.summary,.expanded-toggle) {
    cursor: pointer;
  }

.expanded-toggle::after {
    background: var(--gray-06);
    content: '';
    display: block;
    height: var(--icon-size);
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
            mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    -webkit-mask-position: center;
            mask-position: center;
    -webkit-mask-size: 20px;
            mask-size: 20px;
    width: var(--icon-size);
  }

:host([expanded]) .expanded-toggle::after {
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
            mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }

:is(.expanded-toggle:hover,.summary:hover ~ .expanded-toggle)::after {
      background: var(--gray-08);
    }

:host(:not([expanded])) .content {
  display: none;
}

:host([non-toggleable]) .summary-aside {
    margin-right: calc(var(--space-2)*-1);
  }

:host([non-toggleable]) .expanded-toggle {
    display: none;
  }
`, "",{"version":3,"sources":["webpack://./src/ui/utils/focus-outline.css","webpack://./src/ui/disclosure/disclosure.module.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa,EAAE,0DAA0D;EACzE,gDAAgD,EAAE,8BAA8B;AAOlF;;AALE;IACE,kCAAkC,EAAE,uCAAuC;IAC3E,kDAAkD;IAClD,sDAAsD;EACxD;;AAGF;EACE,+BAA+B;AACjC;;ACZA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gBAAgB;AAKlB;;AAHE;IACE,eAAe;EACjB;;AAIA;IACE,0BAA0B;IAC1B,WAAW;IACX,cAAc;IACd,wBAAwB;IACxB,2DAAwD;YAAxD,mDAAwD;IACxD,6BAAqB;YAArB,qBAAqB;IACrB,uBAAe;YAAf,eAAe;IACf,uBAAuB;EACzB;;AAEA;IACE,2DAAsD;YAAtD,mDAAsD;EACxD;;AAIE;MACE,0BAA0B;IAC5B;;AAIJ;EACE,aAAa;AACf;;AAGE;IACE,qCAAuC;EACzC;;AAEA;IACE,aAAa;EACf","sourcesContent":[".focus-outline,\n.focus-outline-keynav {\n  outline: none; /* disable the native focus outline (for :focus-visible) */\n  transition: box-shadow var(--default-transition); /* animate our focus outline */\n\n  &:focus {\n    border-radius: var(--outline, 1px); /* add rounded corners to the outline */\n    box-shadow: var(--outline, var(--default-outline));\n    outline: var(--outline, var(--default-native-outline));\n  }\n}\n\n.focus-outline-keynav {\n  --outline: var(--is-not-keynav);\n}\n","@import 'ui/utils/focus-outline.css';\n\n.summary,\n.expanded-toggle {\n  background: none;\n  border: none;\n  padding: 0;\n  text-align: left;\n\n  :host(:not([non-toggleable])) & {\n    cursor: pointer;\n  }\n}\n\n.expanded-toggle {\n  &::after {\n    background: var(--gray-06);\n    content: '';\n    display: block;\n    height: var(--icon-size);\n    mask-image: url('~@disy/cadenza-icons/chevron-down.svg');\n    mask-position: center;\n    mask-size: 20px;\n    width: var(--icon-size);\n  }\n\n  :host([expanded]) &::after {\n    mask-image: url('~@disy/cadenza-icons/chevron-up.svg');\n  }\n\n  &:hover,\n  .summary:hover ~ & {\n    &::after {\n      background: var(--gray-08);\n    }\n  }\n}\n\n:host(:not([expanded])) .content {\n  display: none;\n}\n\n:host([non-toggleable]) {\n  .summary-aside {\n    margin-right: calc(-1 * var(--space-2));\n  }\n\n  .expanded-toggle {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
